import React from 'react';
import Project_overview from '../pages/Project_overview';
import Gantt from '../images/Gantt.png';
import '../css/BlockDiagram.css'; // Import your external CSS

const Gantt_Chart = () => {
  return (
    <div className="all-div">
      <Project_overview />
      <div className="gantt-chart-container">
        <img src={Gantt} alt="Gantt_chart" />
      </div>
    </div>
  );
}

export default Gantt_Chart;
